// extracted by mini-css-extract-plugin
export default {"h2":"H2-module__h2___LmfY5","bold":"H2-module__bold___BbqMD","muted":"H2-module__muted___chOUc","inline":"H2-module__inline___C5pbe"};